import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ToastController} from '@ionic/angular';

@Injectable({providedIn: 'root'})
export class ApiTokenService {

  private readonly storageKey = 'milenalatusorella-api-token';
  private handlingUnauthorized = false;

  constructor(
    private router: Router,
    private toastController: ToastController
  ) {}

  getToken(): string | null {
    const storedToken = this.storage?.getItem(this.storageKey)?.trim();
    return storedToken ? storedToken : null;
  }

  hasToken(): boolean {
    return this.getToken() !== null;
  }

  setToken(token: string) {
    const normalizedToken = token.trim();
    if (!normalizedToken) {
      this.clearToken();
      return;
    }

    this.storage?.setItem(this.storageKey, normalizedToken);
  }

  clearToken() {
    this.storage?.removeItem(this.storageKey);
  }

  async ensureTokenForNavigation(): Promise<boolean> {
    if (this.hasToken()) {
      return true;
    }

    await this.redirectHomeWithToast(
      'Inserisci un token dalla Home per accedere alle altre pagine.',
      'warning'
    );
    return false;
  }

  async handleUnauthorizedResponse(): Promise<void> {
    if (this.handlingUnauthorized) {
      return;
    }

    this.handlingUnauthorized = true;
    try {
      this.clearToken();
      await this.redirectHomeWithToast(
        'Token non valido. Inseriscilo di nuovo dalla Home.',
        'danger'
      );
    } finally {
      this.handlingUnauthorized = false;
    }
  }

  private get storage(): Storage | null {
    return typeof window === 'undefined' ? null : window.localStorage;
  }

  private async redirectHomeWithToast(
    message: string,
    color: 'danger' | 'warning'
  ) {
    if (!this.router.url.startsWith('/home')) {
      await this.router.navigate(['/home']);
    }

    const toast = await this.toastController.create({message, duration: 3000, color});
    await toast.present();
  }
}
